import React, { memo } from 'react'
import tw from 'twin.macro'
import { InputAdornment } from '@mui/material'
import { useFormikContext } from 'formik'
import { Button } from 'src/components/shared/Button'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import type { PartnerDriverProfileFormValues } from './PartnerDriverProfileForm.interface'

interface Props {
  isSaving: boolean
  isReadOnly: boolean
}

const PartnerDriverProfileFormContentComponent = ({ isSaving, isReadOnly }: Props) => {
  const { dirty } = useFormikContext<PartnerDriverProfileFormValues>()

  return (
    <div css={tw`flex flex-col gap-4`}>
      <div css={tw`grid grid-cols-1 gap-4 md:grid-cols-2`}>
        <FormikTextField<PartnerDriverProfileFormValues>
          name="firstName"
          label="First name *"
          placeholder="First name"
          disabled={isReadOnly}
        />
        <FormikTextField<PartnerDriverProfileFormValues>
          name="lastName"
          label="Last name *"
          placeholder="Last name"
          disabled={isReadOnly}
        />
        <FormikTextField<PartnerDriverProfileFormValues>
          name="email"
          label="Email *"
          placeholder="Email"
          disabled={isReadOnly}
        />
        <FormikTextField<PartnerDriverProfileFormValues>
          name="phone"
          label="Phone *"
          placeholder="Phone"
          disabled={isReadOnly}
        />
        <FormikTextField<PartnerDriverProfileFormValues>
          name="reimbursementAmount"
          label="Reimbursement amount"
          placeholder="0.00"
          disabled={isReadOnly}
          InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
          inputProps={{ inputMode: 'decimal' }}
        />
        <FormikTextField<PartnerDriverProfileFormValues>
          name="reimbursementPercentage"
          label="Reimbursement percentage"
          placeholder="0"
          disabled={isReadOnly}
          InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
          inputProps={{ inputMode: 'decimal' }}
        />
      </div>
      {isReadOnly ? null : (
        <div css={tw`flex justify-end`}>
          <Button
            size="small"
            color="dark"
            type="submit"
            css={tw`px-4`}
            loading={isSaving}
            disabled={!dirty || isSaving}
            data-testid="partner-driver-profile-save-button"
          >
            Save changes
          </Button>
        </div>
      )}
    </div>
  )
}

export const PartnerDriverProfileFormContent = memo(PartnerDriverProfileFormContentComponent)
